import api from './connectionProxy'

export const login = ({ cpf, password }) => {
  return api.http.post('/auth/login', {
    cpf,
    password,
  })
}

export const resetPasswordByEmail = (email) => {
  return api.http.post('/auth/reset_password', {
    email,
  })
}

export const resetPassword = ({ senha, token }) => {
  return api.http.put(`/auth/reset_password/${token}`, {
    senha,
  })
}

export const refreshToken = (token) => {
  return api.http.post('/auth/refresh_token', {
    refreshToken: token,
  })
}

export const logout = () => {
  return new Promise((resolve, reject) => {
    resolve('ok')
  })
}



// WEBPACK FOOTER //
// ./src/api/auth.js